import { useState, useEffect } from 'react';
import { Container, Card, Table, Badge, Spinner } from 'react-bootstrap';
import { getLevelUsers } from '../../api/userApi';
import { fmtIST } from '../../utils/dateFormat';

const levelColors = ['primary', 'success', 'warning', 'danger', 'info', 'secondary', 'dark', 'primary', 'success', 'warning'];

const LevelUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLevelUsers()
      .then((res) => setUsers(res.data.levelUsers))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Container className="mt-5 text-center"><Spinner animation="border" /></Container>;

  return (
    <Container className="mt-4">
      <h4>Level Users <Badge className="ms-2" style={{ background: 'var(--cyan)', color: 'var(--bg)' }}>{users.length}</Badge></h4>
      <Card className="shadow-sm mt-3">
        <Table responsive hover className="mb-0">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Level</th>
              <th>Name</th>
              <th>User Code</th>
              <th>Upline Code</th>
              <th>Latest Upgraded Slot</th>
              <th>Slot Activation Date</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan={8} className="text-center text-muted py-4">No level users yet</td>
              </tr>
            ) : (
              users.map((u, i) => (
                <tr key={u._id}>
                  <td>{i + 1}</td>
                  <td>
                    <Badge bg={levelColors[u.level - 1]}>Level {u.level}</Badge>
                  </td>
                  <td>{u.name}</td>
                  <td><code>{u.userCode}</code></td>
                  <td>{u.uplineCode ? <code>{u.uplineCode}</code> : '—'}</td>
                  <td>{u.latestSlot || 'Registered'}</td>
                  <td>{u.latestSlotDate ? fmtIST(u.latestSlotDate) : '-'}</td>
                  <td>{fmtIST(u.createdAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card>
    </Container>
  );
};

export default LevelUsers;
